module.exports = __webpack_public_path__ + "static/media/Arcade-Cabinet-rev2.57d7a5fa.doc";